import { cacheMatchesQuery } from './addressCacheMatch';

/** Field stamped onto cadastre results with the exact search string used to fetch them. */
export const CADASTRE_QUERY_TAG = 'queriedAddress';

/** Legacy RDPPF soft-fail: status ok but no registry surface — must not be treated as fetched. */
export function isIncompleteCadastreCache(cachedData) {
  return Boolean(
    cachedData &&
    cachedData.status === 'ok' &&
    !(Number(cachedData.surface_m2) > 0),
  );
}

/** Attach the exact search query this cadastre payload was fetched for. */
export function tagCadastreWithQuery(result, query) {
  if (!result || typeof result !== 'object') return result;
  const q = String(query || '').trim();
  if (!q) return { ...result };
  return { ...result, [CADASTRE_QUERY_TAG]: q };
}

/**
 * Single source of truth: does this cadastre payload belong to the current search line?
 * 1) If tagged with queriedAddress → exact (case-insensitive) query match only.
 * 2) Legacy (no tag) → label heuristic via cacheMatchesQuery.
 */
export function cadastreBelongsToQuery(query, cadastreData) {
  if (!cadastreData || cadastreData.status !== 'ok' || isIncompleteCadastreCache(cadastreData)) {
    return false;
  }
  if (!query || String(query).trim().length < 5) return false;
  const q = String(query).trim();
  const tagged = typeof cadastreData[CADASTRE_QUERY_TAG] === 'string'
    ? cadastreData[CADASTRE_QUERY_TAG].trim()
    : '';
  if (tagged) {
    return tagged.toLowerCase() === q.toLowerCase();
  }
  return cacheMatchesQuery(q, cadastreData.address);
}

/**
 * Whether a forced refetch for `address` is allowed (prevents hydrate↔refetch loops).
 * Returns the next guard value to store, or null if the bump must be skipped.
 */
export function nextForcedRefetchGuard(previousGuard, address) {
  const a = String(address || '').trim();
  if (!a || a.length < 5) return null;
  if (previousGuard === a) return null;
  return a;
}
